import { useEffect } from "react";

const APP_NAME = "PerkSpot Travel";

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = `${APP_NAME} | ${title}`;
  }, [title]);
};
